import removeTableFromStore from '../actions/store-factory/removeTableFromStore';
import { removeSearchTableFromStore } from 'owa-mail-search';
import { orchestrator } from 'satcheljs';
export default orchestrator(removeSearchTableFromStore, function (actionMessage) {
    removeTableFromStore(actionMessage.tableViewId);
});
//# sourceMappingURL=removeSearchTableFromStoreOrchestrator.js.map